import React from 'react';

// Styles & Assets
import styles from './PatientAlertElement.module.css';
import { ReactComponent as ArrowUp } from '../../../assets/icons/arrow-up.svg'
import { ReactComponent as ArrowDown } from '../../../assets/icons/arrow-down.svg'

// Hooks
import { useTranslation } from "react-i18next";

// Interfaces
import { IPatientInquiryAlert, IPatientScoreAlert, IPreConfigParameterAlert, IScoreParameterAlert } from "../../../interfaces/Score";

export const InquiryAlertElement = ({ inquiryAlert }: { inquiryAlert: IPatientInquiryAlert }) => {
    const { t } = useTranslation();

    return (
        <p className={styles.alertText}>
            <span className={styles.pollLabel}>{t('poll')}</span> {inquiryAlert.inquiry_alert.Inquiry?.name || ''}
        </p>
    );
};

export const PatientScoreAlert = ({
    scoreAlert,
    arrowColor,
}: {
    scoreAlert: IPatientScoreAlert
    arrowColor?: string
}) => {
    const getResult = (num: number, alert: number | string) => {
        const result = Math.abs(num - Number(alert));
        const roundedResult = Math.round(result * 100) / 100;
        return roundedResult;
    };

    const getLimitAlert = (
        num: number | string | undefined | null,
        paramAlert?: IScoreParameterAlert | null,
        preconfigAlert?: IPreConfigParameterAlert | null
    ) => {
        if (num === null || num === undefined || (!paramAlert && !preconfigAlert)) return null;

        const parsedNum = Number(num);
        const max = paramAlert?.alert_max_range?? preconfigAlert?.max_limit;
        const min = paramAlert?.alert_min_range?? preconfigAlert?.min_limit;

        if (Number.isNaN(parsedNum)) return null;

        if (max != null && parsedNum > Number(max)) {
            const res = getResult(parsedNum, max);
            return { direction: 'up', res };
        }

        if (min != null && parsedNum < Number(min)) {
            const res = getResult(parsedNum, min);
            return { direction: 'down', res };
        }

        return null;
    };

    const alertStatus = getLimitAlert(
        scoreAlert.physiological_monitoring?.value,
        scoreAlert.score_parameter_alert,
        scoreAlert.preconfig_sheet_parameter
    );

    return (
        <>
            {scoreAlert.sheet_parameter?.name || ''}: {scoreAlert.physiological_monitoring?.value ?? ''} {scoreAlert.sheet_parameter?.measurement_unit ?? ''}
            {alertStatus &&
                <span className={styles.alertVariation}>
                    <>
                        ({alertStatus.direction === 'up' ?
                            <ArrowUp
                                className={`${styles.arrow} ${styles.up}`}
                                style={{ fill: arrowColor ? arrowColor : undefined }}
                            />
                            :
                            <ArrowDown
                                className={`${styles.arrow} ${styles.down}`}
                                style={{ fill: arrowColor ? arrowColor : undefined }}
                            />
                        }
                        {alertStatus.res})
                    </>
                </span>
            }
        </>
    );
};